// extracted by mini-css-extract-plugin
module.exports = {"root":"content-box_root__1XN5K","secondary":"content-box_secondary__Q7uZ6","footer":"content-box_footer__TAOD_"};